import React, { useContext } from 'react';
import { DynamicComponentsContext } from './PortalApp';

export const DeclaredComponentWrapper = React.createContext(comp => comp);

export function DynamicComponent({ componentId, valueMap, ...props }) {
  const dynamicComponents = useContext(DynamicComponentsContext);
  const Component = dynamicComponents[componentId];

  let newProps = props;

  if (valueMap) {
    Object.keys(valueMap).forEach(key => {
      if (props.attr === key) {
        newProps = { ...props, value: valueMap[key] };
      }
    });
  }

  if (!Component) {
    throw `component ${componentId} is not registered. User `;
  }
  return <Component {...newProps} />;
}

export function DeclaredComponent({ declaration, children, valueMap, ...props }) {
  const componentId = Object.keys(declaration)[0];
  let declaredProps = declaration[componentId];
  const content = declaredProps.content;
  if (!children && content) {
    children = childrenFromContent(content, valueMap);
  }
  const wrapper = useContext(DeclaredComponentWrapper);
  return wrapper(
    <DynamicComponent valueMap={valueMap} componentId={componentId} {...declaredProps} {...props}>
      {children}
    </DynamicComponent>,
    declaration,
    componentId,
    declaredProps
  );
}

export function DeclaredComponentList({ declarations, valueMap }) {
  return declarations.map((decl, i) => (
    <DeclaredComponent valueMap={valueMap} key={i} declaration={decl} />
  ));
}

function childrenFromContent(content, valueMap) {
  if (Array.isArray(content)) {
    return <DeclaredComponentList valueMap={valueMap} declarations={content} />;
  } else {
    return <DeclaredComponent valueMap={valueMap} declaration={content} />;
  }
}


export function traversePresentationMetadata(rootDeclaration, callback) {
  const stack = [rootDeclaration];
  while (stack.length) {
    const declaration = stack.pop();
    const componentId = Object.keys(declaration)[0];
    const props = declaration[componentId];
    callback(componentId, props, declaration);
    if (props.content) {
      if (Array.isArray(props.content)) {
        props.content.forEach(child => stack.push(child));
      } else {
        stack.push(props.content);
      }
    }
  }
}
